<template>
  <div>
    <el-dialog title="订单详情" :visible="visibile" :before-close="handleClose">
      <!-- <my-popup title="订单详情" width="1090"> -->
      <div class="orderDetails">
        <p class="tips"><i></i>订单信息</p>
        <div class="details">
          <span v-if="permissions.indexOf('hide:order:presellOrder') ==-1 ">订单编号：{{ detailData.orderId }}</span>
          <span>付款方式：{{ detailData.payType }}</span>
          <span>送货类型：{{ detailData.deliveryType }}</span>
          <span>买家账号：{{ detailData.desensitizePin }}</span>
          <span>买家姓名：{{ detailData.fullName }}</span>
          <!-- <span>买家号码：{{(detailData.mobile || '--') | mobileEllipsis}}</span> -->
          <span>订单总金额：{{ detailData.orderSellerPrice }}</span>
          <span>实付金额：{{ detailData.orderPayment }}</span>
          <span>优惠金额：{{ detailData.sellerDiscount }}</span>
          <span>邮费：{{ detailData.freightPrice }}</span>
          <span>订单状态：{{ detailData.orderStateRemark }}</span>
          <span>发票信息：{{ detailData.invoiceInfo }}</span>
          <span>下单时间：{{ detailData.orderStartTime }}</span>
          <span>最后修改时间：{{ detailData.modified }}</span>
          <span>付款时间：{{ detailData.paymentConfirmTime }}</span>
          <span>买家备注： {{ detailData.orderRemark }}</span>
          <span>商家备注：{{ detailData.venderRemark }}</span>
          <span>所属省份：{{ detailData.province }}</span>
          <span>详细地址：{{ detailData.fullAddress }}</span>
        </div>
        <p class="tips"><i></i>商品详情</p>
        <el-table :data="jdItemInfo" header-row-class-name="row" border style="width: 100%; margin-bottom: 16px;" max-height="150">
          <el-table-column prop="skuName" label="商品的名称+SKU规格"></el-table-column>
          <el-table-column prop="itemTotal" label="数量" width="100"></el-table-column>
          <el-table-column prop="jdPrice" width="150" label="SKU的价格"></el-table-column>
        </el-table>
        <p class="tips"><i></i>优惠类型</p>
        <el-table :data="couponDetailList" border style="width: 100%">
          <el-table-column prop="couponType" label="优惠类型"></el-table-column>
          <el-table-column prop="skuId" label="京东sku编号"></el-table-column>
          <el-table-column prop="couponPrice" label="优惠金额"></el-table-column>
        </el-table>
      </div>
      <!-- </my-popup> -->
    </el-dialog>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/tbOrder";
export default {
  name: "",
  props: {
    visibile: {
      type: Boolean,
      default: true,
    },
    orderId: {
      type: Number,
      default: "",
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    permissions() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  filters: {},
  data() {
    return {
      orderDetail: true,
      couponDetailList: [], // 优惠券列表
      jdItemInfo: [],
      detailData: {},
    };
  },
  mounted() {
    console.log("this.orderId", this.orderId);
    this.getDetailData();
  },
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
    getDetailData() {
      console.log("this.orderId", this.orderId);
      getOrderDetail(this.orderId).then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.detailData = res.data;
          if (res.data.couponDetailList) {
            this.couponDetailList = res.data.couponDetailList;
          }
          if (res.data.itemInfoList) {
            this.jdItemInfo = res.data.itemInfoList;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding-top: 0;
}

.orderDetails {
  box-sizing: border-box;
  padding: 20px 0 20px;
  .tips {
    box-sizing: border-box;
    height: 32px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    margin: 0 0 20px 0;
    background: rgba(250, 250, 250, 1);
    color: #333333;
    font-size: 14px;
    i {
      width: 3px;
      height: 14px;
      margin-right: 8px;
      background-color: #fe4d45;
      border-radius: 3px;
    }
  }
  .details {
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      width: 33.3%;
      margin-bottom: 12px;
      color: #333;
      font-size: 14px;
      &:last-child {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
  /deep/ .row {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04) !important;
  }
  /deep/ .el-table--small td {
    padding: 16px 0;
  }
}
</style>
